import React from 'react';

/**
 * Message d'erreur de chargement pour un écran staff. Distingue le cas session
 * expirée (401 → invite à se reconnecter, la bannière globale gère l'action) du
 * cas erreur générique (réseau / backend). Un 200 avec data vide n'utilise PAS
 * ce composant : chaque écran affiche son propre placeholder « aucune donnée ».
 */
export type StaffLoadErrorKind = 'auth' | 'error';

export function StaffLoadError({ kind }: { kind: StaffLoadErrorKind }) {
  return (
    <p className="staff-empty" style={{ color: 'var(--color-error)' }}>
      {kind === 'auth'
        ? 'Session expirée — reconnecte-toi depuis l’onglet Mon compte, ou mets à jour l’app si le problème persiste.'
        : 'Données indisponibles pour le moment. Réessaie dans un instant.'}
    </p>
  );
}
